const setItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const getItem = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

const clearItem = (key) => {
  localStorage.removeItem(key);
};

export { setItem, getItem, clearItem };
